import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectSummary = ({ projectData }) => {
  const {
    name = "My Generated Project",
    fileCount = 42,
    compressedSize = "2.4 MB",
    components = []
  } = projectData;

  const defaultComponents = [
    { name: "Frontend (React)", icon: "Layout", color: "text-blue-400" },
    { name: "Backend (Node.js)", icon: "Server", color: "text-green-400" },
    { name: "Database Schemas", icon: "Database", color: "text-purple-400" },
    { name: "Documentation", icon: "FileText", color: "text-yellow-400" }
  ];

  const displayComponents = components?.length > 0 ? components : defaultComponents;

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 border border-border">
      <h3 className="text-base md:text-lg font-semibold mb-4 flex items-center gap-2">
        <Icon name="Package" size={20} className="text-primary" />
        Project Summary
      </h3>
      <div className="space-y-3 md:space-y-4">
        <div className="flex items-center justify-between py-2 md:py-3 border-b border-border">
          <span className="text-sm md:text-base text-muted-foreground">Project Name</span>
          <span className="text-sm md:text-base font-medium truncate ml-4">{name}</span>
        </div>

        <div className="flex items-center justify-between py-2 md:py-3 border-b border-border">
          <span className="text-sm md:text-base text-muted-foreground">Total Files</span>
          <span className="text-sm md:text-base font-medium">{fileCount}</span>
        </div>

        <div className="flex items-center justify-between py-2 md:py-3 border-b border-border">
          <span className="text-sm md:text-base text-muted-foreground">Compressed Size</span>
          <span className="text-sm md:text-base font-medium">{compressedSize}</span>
        </div>

        <div className="pt-2 md:pt-3">
          <p className="text-sm md:text-base text-muted-foreground mb-3">Included Components:</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3">
            {displayComponents?.map((component, index) => (
              <div
                key={index}
                className="flex items-center gap-2 p-2 md:p-3 bg-muted rounded-md"
              >
                <Icon name={component?.icon} size={16} className={component?.color} />
                <span className="text-xs md:text-sm font-medium truncate">{component?.name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSummary;